import { ProjectParams } from '@/backend/access/project/types';
import { File } from './file';

export class Project {
  id: string;
  description: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  parentId: string;
  parentType: string;
  file?: File;
  title: string;
  propelOrgId: string;

  constructor(params: ProjectParams) {
    this.id = params.id;
    this.description = params.description;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.parentId = params.parentId;
    this.parentType = params.parentType;
    this.file = params.file ? new File(params.file) : undefined;
    this.title = params.name || params.title;
    this.propelOrgId = params.propelOrgId || '';
  }
}


export enum ProjectParentType {
  WORKSPACE = 'workspace',
  ORGANIZATION = 'organization',
}